import { cn } from "@workspace/ui/lib/utils";

export const FIVEONEFOUR_LOGO_PATH =
  "M226.913 302.559H151.273V226.935H226.913V302.559ZM302.547 186.885H302.557V226.929H226.918V111.255L302.547 186.885ZM226.913 191.335H75.6445V111.255H226.913V191.335ZM75.6387 111.242H0V0.00292969H75.6387V111.242ZM151.282 0.00292969H226.913V75.6426H75.6445V0H151.282V0.00292969Z";

export function PlatformAppLogo({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 shrink-0", className)}
      fill="none"
      viewBox="0 0 303 303"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={FIVEONEFOUR_LOGO_PATH} fill="currentColor" />
    </svg>
  );
}

/**
 * 514 mark for `global-error.tsx`. Uses the `global-error-logo` class from
 * `GlobalHttpErrorPage` inline styles (Tailwind is not loaded on that document).
 */
export function GlobalErrorBrandLogo() {
  return (
    <svg
      aria-hidden="true"
      className="global-error-logo"
      fill="none"
      viewBox="0 0 303 303"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={FIVEONEFOUR_LOGO_PATH} fill="currentColor" />
    </svg>
  );
}
